import { render } from "./ReviewsTab.vue?vue&type=template&id=24c80ec1&scoped=true"
import script from "./ReviewsTab.vue?vue&type=script&lang=js"
export * from "./ReviewsTab.vue?vue&type=script&lang=js"

import "./ReviewsTab.vue?vue&type=style&index=0&id=24c80ec1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c80ec1"]])

export default __exports__